package lacaravana.ui

import kotlinx.browser.document
import kotlinx.coroutines.launch
import kotlinx.html.*
import kotlinx.html.dom.append
import kotlinx.html.js.onClickFunction
import lacaravana.app.Database
import lacaravana.app.appScope
import lacaravana.domain.Menu
import lacaravana.domain.Pedido

object PedidoView {
    var currentMesaId: Int = 0
    private var currentPedidoId: String? = null

    suspend fun render(db: Database) {
        val content = document.getElementById("content") ?: return
        content.innerHTML = ""
        if (currentMesaId == 0) return

        val pedido = Pedido.findByMesa(db, currentMesaId)
        currentPedidoId = if (pedido == null) Pedido.create(db, currentMesaId) else pedido.id
        val pedidoId = currentPedidoId ?: return

        val items = Pedido.itemsFor(db, pedidoId)
        val menuItems = Menu.available(db)

        content.append {
            h2 { +"Pedido Mesa $currentMesaId" }
            div("card") {
                h3 { +"Añadir al pedido" }
                div("menu-pick") {
                    for (mi in menuItems) {
                        button {
                            attributes["data-menu-item"] = mi.id
                            +"${mi.nombre} (${Menu.formatPrice(mi.precioCents)})"
                            onClickFunction = {
                                appScope.launch {
                                    Pedido.addItem(db, pedidoId, mi.id)
                                    render(db)
                                }
                            }
                        }
                    }
                }
            }
            if (items.isNotEmpty()) {
                table {
                    thead {
                        tr {
                            th { +"Item" }
                            th { +"Cant." }
                            th { +"Estado" }
                            th { +"Precio" }
                        }
                    }
                    tbody {
                        for (item in items) {
                            tr {
                                attributes["data-pedido-item"] = item.menuItemNombre
                                td { +item.menuItemNombre }
                                td { +item.cantidad.toString() }
                                td { span("badge badge-${item.estado}") { +item.estado } }
                                td { +Menu.formatPrice(item.precioCents * item.cantidad) }
                            }
                        }
                    }
                }
                val total = items.sumOf { it.precioCents * it.cantidad }
                p {
                    id = "pedido-total"
                    +"Total: ${Menu.formatPrice(total)}"
                }
            }
        }
    }
}
